import dayjs from "dayjs"
import { TimeOnly } from "../@client/System"

export function timeOnlyToDayjs(timeOnlyString: TimeOnly) {
  const dateTimeString = `2000-01-01 ${timeOnlyString}`
  return dayjs(dateTimeString, "YYYY-MM-DD HH:mm:ss")
}
